import { createApp } from 'vue'
// import DayGenerate from './DayGenerate.vue';
import ReservationCalendar from './ReservationCalendar.vue';

// 日時生成
createApp(ReservationCalendar, {
    api_url : null,
}).mount('#vue-reservation-calendar');